"use client"

import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Fragment, useMemo } from "react"
import HotelGoodPriceItem from "./HotelGoodPriceItem"
import { flattenHotelGoodPriceProducts } from "./flattenHotelGoodPriceProducts"

const HotelGoodPricesMobile = ({ data }: { data: any[] }) => {
  const isDesktop = useIsDesktop()

  const sortedProducts = useMemo(
    () => flattenHotelGoodPriceProducts(data),
    [data],
  )

  if (isDesktop) {
    return <Fragment />
  }

  if (!sortedProducts.length) {
    return <Fragment />
  }

  return (
    <div className="hotels__goodprices--scroll">
      <div className="hotels__goodprices--scroll-track">
        {sortedProducts.map((product) => (
          <div className="hotels__goodprices--scroll-item" key={product.__key}>
            <HotelGoodPriceItem product={product} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default HotelGoodPricesMobile
